<template>
  <el-card shadow="never" class="aui-card--fill">
    <router-link to="/erp-store-log-manager" style="font-size: 18px;color: blue;">该功能已下线,请使用"库存管理-库存记录",点击跳转</router-link>
<!--    <vxe-toolbar ref="xToolbar" custom>-->
<!--      <template v-slot:buttons>-->
<!--        <el-form-->
<!--          :inline="true"-->
<!--          :model="queryForm"-->
<!--          @keyup.enter.native="getDataList()"-->
<!--          ref="queryForm"-->
<!--          class="query-form"-->
<!--        >-->
<!--          <el-form-item prop="orderCode" label="外销合同号：">-->
<!--            <el-input-->
<!--              v-model="queryForm.orderCode"-->
<!--              size="mini"-->
<!--              clearable-->
<!--              type="text"-->
<!--              placeholder="请输入外销合同号"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item prop="storeName" label="仓库：">-->
<!--            <el-input-->
<!--              v-model="queryForm.storeName"-->
<!--              size="mini"-->
<!--              clearable-->
<!--              type="text"-->
<!--              placeholder="请输入仓库名称"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item prop="storeType" label="操作类型：">-->
<!--            <el-select v-model="queryForm.storeType" size="mini" clearable>-->
<!--              <el-option :value="1" label="入库"></el-option>-->
<!--              <el-option :value="-1" label="出库"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item prop="productName" label="品名：">-->
<!--            <el-input-->
<!--              v-model="queryForm.productName"-->
<!--              size="mini"-->
<!--              clearable-->
<!--              type="text"-->
<!--              placeholder="请输入品番号/品名/颜色/规格/幅宽/克重"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item>-->
<!--            <el-button type="primary" @click="getDataList" size="mini"-->
<!--              >查询</el-button-->
<!--            >-->
<!--            <el-button @click="reset" size="mini">重置</el-button>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--      </template>-->
<!--    </vxe-toolbar>-->
<!--    <vxe-table-->
<!--      align="center"-->
<!--      :id="tableConfig.id"-->
<!--      :ref="tableConfig.tableName"-->
<!--      show-overflow-->
<!--      row-id="id"-->
<!--      :height="tableConfig.height"-->
<!--      :loading="tableData.loading"-->
<!--      :data="tableData.dataList"-->
<!--      :cell-style="cellStyleHandler"-->
<!--      :custom-config="{ storage: true, checkMethod: checkColumnHandler }"-->
<!--      @resizable-change="resizableChangeEvent"-->
<!--    >-->
<!--      <vxe-column type="seq" title="行号" width="50"></vxe-column>-->
<!--      <vxe-column-->
<!--        field="agreementCode"-->
<!--        title="合同号"-->
<!--        min-width="160"-->
<!--      ></vxe-column>-->
<!--      <vxe-column-->
<!--        field="storageName"-->
<!--        title="仓库"-->
<!--        :formatter="companyNameFormatter"-->
<!--        min-width="160"-->
<!--      ></vxe-column>-->
<!--      <vxe-column-->
<!--        field="productCode"-->
<!--        title="品番号"-->
<!--        min-width="90"-->
<!--      ></vxe-column>-->
<!--      <vxe-column-->
<!--          field="skuCode"-->
<!--          title="SKU"-->
<!--          min-width="90"-->
<!--      ></vxe-column>-->
<!--      <vxe-column field="productName" title="品名" min-width="90"></vxe-column>-->
<!--      <vxe-column field="nameZh" title="中文名" min-width="90"></vxe-column>-->
<!--      <vxe-column field="color" title="颜色" min-width="90"></vxe-column>-->
<!--      <vxe-column field="size" title="规格" min-width="90"></vxe-column>-->
<!--      <vxe-column-->
<!--      field="operateTime"-->
<!--      title="出入库日期"-->
<!--            width="110"-->
<!--        >-->
<!--        </vxe-column>-->
<!--        <vxe-column title="图片"  width="140">-->
<!--          <template #default="{row}">-->
<!--            <el-image style="width: 100px;height:100px;" :preview-src-list="row.imgs" v-if="row.previewImg"-->
<!--                      :src="row.previewImg" fit="cover"></el-image>-->
<!--          </template>-->
<!--        </vxe-column>-->
<!--      <vxe-column title="出入库类型" width="90" fixed="right">-->
<!--        <template #default="{ row }">-->
<!--          <div style="color: #67c23a" v-if="row.type === 1">入库</div>-->
<!--          <div style="color: #f56c6c" v-else-if="row.type === -1">出库</div>-->
<!--        </template>-->
<!--      </vxe-column>-->
<!--      <vxe-column field="count" title="数量" min-width="90" fixed="right">-->
<!--        <template #default="{ row }">-->
<!--          <div style="color: #67c23a" v-if="row.type === 1">-->
<!--            {{ row.count }}-->
<!--          </div>-->
<!--          <div style="color: #f56c6c" v-else-if="row.type === -1">-->
<!--            {{ row.count }}-->
<!--          </div>-->
<!--        </template>-->
<!--      </vxe-column>-->
<!--    </vxe-table>-->
<!--    <vxe-pager-->
<!--      :loading="tableData.loading"-->
<!--      :current-page="tableData.currentPage"-->
<!--      :page-size="pagerConfig.pageSize"-->
<!--      :total="tableData.total"-->
<!--      :layouts="pagerConfig.layouts"-->
<!--      @page-change="vxePageChanger"-->
<!--    >-->
<!--    </vxe-pager>-->
  </el-card>
</template>

<script>
import VxeTable from "@/mixins/vxe-table";

export default {
  mixins: [VxeTable],
  components: {},
  data() {
    return {
      tableConfig: {
        queryUrl: "/trade/factorystorelog/page",
      },
      queryForm: {
        productType: "产品",
        productName: "",
        orderCode: "",
        storeName: "",
        storeType: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
